import { type RequestAttachment } from 'entities/Attachment/model/RequestAttachment'

export const AgentActionType = {
  AddTag: 1,
  RemoveTag: 2,
  ContactNote: 4,
  SendMessage: 200,
} as const

export type IAgentActionType = (typeof AgentActionType)[keyof typeof AgentActionType]

export type IAgentActionTagPayload = {
  tag_ids: number[]
}

export type IAgentActionNotePayload = {
  note: string
}

export type IAgentMessagePayload = {
  type?: 'manual' | 'auto'
  message: string
  media_url: Omit<RequestAttachment, 'media_preview'>[]
}

type IAgentActionSetting<T extends IAgentActionType, S> = {
  type: T
  settings: S
}

export type IAgentActionAddTagSetting = IAgentActionSetting<
  typeof AgentActionType.AddTag,
  IAgentActionTagPayload
>

export type IAgentActionRemoveTagSetting = IAgentActionSetting<
  typeof AgentActionType.RemoveTag,
  IAgentActionTagPayload
>

export type IAgentActionContactNoteSetting = IAgentActionSetting<
  typeof AgentActionType.ContactNote,
  IAgentActionNotePayload
>

export type IAgentActionSendMessageSetting = IAgentActionSetting<
  typeof AgentActionType.SendMessage,
  IAgentMessagePayload
>

export type IAgentActionSettings =
  | IAgentActionAddTagSetting
  | IAgentActionRemoveTagSetting
  | IAgentActionContactNoteSetting
  | IAgentActionSendMessageSetting
